const ThirdPartyIdentityProviderCallback = () => import('@/views/account/third-party/identity-provider-callback-view.vue');
const ConnectWiseDisclaimer = () => import('@/views/account/third-party/connectwise-disclaimer-view.vue');
const ConnectWiseLogin = () => import('@/views/account/third-party/connectwise-login-view.vue');
const ConnectWiseRegister = () => import('@/views/account/third-party/connectwise-register-view.vue');
const ConnectWiseSuccessLink = () => import('@/views/account/third-party/connectwise-successful-link-view.vue');

export default [
    {
      path: '/Third-Party/:identityProvider/callback',
      name: 'ThirdPartyIdentityProviderCallback',
      component: ThirdPartyIdentityProviderCallback,
      props: route => ({
        identityProvider: route.params.identityProvider,
        code: route.query.code,
      }),
      meta: {
        isUiShown: false,
        subtype: 'account',
        pageClass: 'integration-settings-page',
        pageTitle: 'Callback to connect from identityProvider',
      },
      beforeEnter: (to, from, next) => {
          next();
      },
    },
    {
      path: '/Third-Party/ConnectWiseDisclaimer',
      name: 'ConnectWiseDisclaimer',
      component: ConnectWiseDisclaimer,
      meta: {
        isUiShown: false,
        type: 'general',
        pageClass: 'connectwise-disclaimer-page',
        pageTitle: 'Connect to connectwise',
      },
      beforeEnter: (to, from, next) => {
          next();
      },
    },
    {
      path: '/Third-Party/ConnectWiseSuccessLink',
      name: 'ConnectWiseSuccessLink',
      component: ConnectWiseSuccessLink,
      meta: {
        isUiShown: false,
        type: 'general',
        pageClass: 'connectwise-success-link-page',
        pageTitle: 'Success Link between glasshive and connectwise',
      },
      beforeEnter: (to, from, next) => {
          next();
      },
    },
    {
      path: '/Third-Party/ConnectWiseLogin',
      name: 'ConnectWiseLogin',
      component: ConnectWiseLogin,
      meta: {
        isUiShown: false,
        type: 'general',
        pageClass: 'connectwise-login-page',
        pageTitle: 'Login to glasshive and connect connectwise',
      },
      beforeEnter: (to, from, next) => {
          next();
      }, 
    },
    {
      path: '/Third-Party/ConnectWiseRegister',
      name: 'ConnectWiseRegister',
      component: ConnectWiseRegister,
      meta: {
        isUiShown: false,
        type: 'general',
        pageClass: 'connectwise-register-page',
        pageTitle: 'Register to glasshive and connect connectwise',
      },
      beforeEnter: (to, from, next) => {
          next();
      }, 
    }
]
